import type { GenerationTier } from '../../types';

export const TIER_COLORS: Record<GenerationTier, string> = {
  tier1: '#60A5FA',
  tier2: '#8B5CF6',
  tier3: '#F59E0B',
  tier4: '#10B981',
};

export const TIER_LABELS: Record<GenerationTier, string> = {
  tier1: 'Tier 1',
  tier2: 'Tier 2',
  tier3: 'Tier 3',
  tier4: 'Tier 4',
};
